import { default as Route } from './Route';

export default Route;
